/* istanbul ignore file */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function IndeterminateCheckbox({ checked, onChange, label }) {
  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = checked === 'indeterminate';
    }
  }, [checked]);

  return (
    <div className="form-control border-0">
      <input
        style={{ verticalAlign: 'middle' }}
        type="checkbox"
        ref={checkboxRef}
        checked={checked === 'true'}
        onChange={onChange}
        aria-label={label}
      />
    </div>
  );
}
IndeterminateCheckbox.defaultProps = { label: 'indeterminate checkbox' };
IndeterminateCheckbox.propTypes = {
  checked: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default IndeterminateCheckbox;
